import type { FC } from "react";
import styled from "styled-components";
import { colorsPalettes } from "@similarweb/styles";
import { setFontVariant } from "@similarweb/styles";
import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import { percentageSignFilter } from "app/filters/ngFilters";
import { ChangeValue } from "@similarweb/ui-components";

const TooltipContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    ${setFontVariant("input2")};
`;

const TooltipMarkerName = styled.span<{ marginRight?: number }>`
    ${({ marginRight }) => marginRight && `margin-right: ${marginRight}px;`};
    color: ${colorsPalettes.carbon[500]};
`;

const TooltipMarker = styled.span<{ backgroundColor: string }>`
    flex-shrink: 0;
    background: ${({ backgroundColor }) => backgroundColor};
    border-radius: 100%;
    height: 12px;
    width: 12px;
    margin-right: 14px;
`;

interface IBulletTooltip {
    color: string;
    name: string;
    value: string;
}

export const BulletTooltip: FC<IBulletTooltip> = (props) => {
    const { color, value, name } = props;
    return (
        <TooltipContainer>
            <TooltipMarker backgroundColor={color} />
            <TooltipMarkerName marginRight={48}>{name}</TooltipMarkerName>
            <TooltipMarkerName>{value}</TooltipMarkerName>
        </TooltipContainer>
    );
};

interface IBulletTooltipWithChange extends IBulletTooltip {
    change: number;
}

const BulletTooltipWithChange: FC<IBulletTooltipWithChange> = (props) => {
    const { change, ...rest } = props;
    if (!change) {
        return <BulletTooltip {...rest} />;
    }
    return (
        <FlexRow
            gap={"16px"}
            alignItems={"center"}
        >
            <BulletTooltip {...rest} />
            <ChangeValue
                value={percentageSignFilter()(change, 2)}
                isDecrease={change < 0}
            />
        </FlexRow>
    );
};
